import { TableCell } from '@client/toolkit';

export const InputCell = ({
  value,
  onChange,
  onBlur,
  placeholder,
  className,
  disabled = false,
}: {
  value: number | null;
  onChange: (value: number) => void;
  onBlur?: () => void;
  placeholder: string;
  className?: string;
  disabled?: boolean;
}) => {
  return (
    <TableCell size="small" className={className ?? 'px-3 py-0 text-xs'}>
      <input
        type="number"
        className="bg-surface-base border border-border rounded-md py-1 w-24 text-right float-right focus:outline-none focus:border-brand-primary"
        placeholder={placeholder}
        value={value || ''}
        onChange={(e) => onChange(Number(e.target.value))}
        onBlur={onBlur}
        disabled={disabled}
        onClick={(e) => e.preventDefault()}
      />
    </TableCell>
  );
};
